import { toast } from "sonner";
import { queryClient } from "@/lib/queries";
import { connectFolderGit } from "@/workspace/git-panel";
import { activeWorkspace } from "@/workspace/file-ops";
import { openFolderInProject } from "@/workspace/local-copy";
import { desktop, navigateTo } from "./bridge";

/**
 * Arquivo › Abrir pasta. Com um projeto aberto, a pasta (código e subpastas) entra nele e passa a
 * ser a pasta dele no computador; com .git, o repositório liga sozinho. Fora de um projeto, cria um
 * projeto novo a partir da pasta (com o repositório, se houver).
 */
export async function openLocalFolderInEditor() {
  if (!desktop?.local) return;
  const ws = activeWorkspace.current;
  if (!ws) {
    navigateTo(`/projects?novo=pasta-${Date.now()}`);
    return;
  }
  if (ws.session.role !== "owner" && !ws.session.canWrite) {
    toast.error("Seu papel neste projeto não permite trazer arquivos para ele.");
    return;
  }
  await openFolderInProject(
    ws.session,
    { id: ws.detail.project.id, name: ws.detail.project.name },
    (remote, branch) => void connectFolderGit(ws.detail.project.id, remote, branch, queryClient),
  );
}
